module.exports = __webpack_public_path__ + "img/svg/isotipo.54fd7ef5db4dd40253875f7995591c72.svg";